module.exports = __webpack_public_path__ + "static/media/Sohne-Leicht.67800f63.otf";